import React, { useMemo } from 'react';
import classNames from 'classnames';
import SectionTrail from '../../../components/SectionTrail/SectionTrail';
import { ONBOARDING_STEPS } from '../onboardingRegistrationConfig';

function buildOnboardingTrailSections(activeStep, completedSteps, gateLocked) {
  return ONBOARDING_STEPS.map((step, index) => {
    let status = 'incomplete';
    if (!gateLocked) {
      if (index === activeStep) status = 'active';
      else if (completedSteps.indexOf(index) >= 0) status = 'complete';
      else if (index < activeStep) status = 'in-progress';
    }

    const navigable =
      !gateLocked &&
      index !== activeStep &&
      !(index > activeStep && completedSteps.indexOf(index - 1) < 0);

    return {
      key: String(index),
      label: step.title,
      short: step.shortTitle,
      color: step.color,
      status,
      navigable,
    };
  });
}

export default function OnboardingProgressSteps({
  activeStep,
  completedSteps,
  gateLocked,
  onStepSelect,
}) {
  const sections = useMemo(
    () => buildOnboardingTrailSections(activeStep, completedSteps, gateLocked),
    [activeStep, completedSteps, gateLocked],
  );

  const handleStepClick = (section) => {
    if (!onStepSelect) return;
    onStepSelect(Number(section.key));
  };

  return (
    <div
      className={classNames('onboarding-registration-progress-trail', {
        'onboarding-registration-progress-trail--gated': gateLocked,
      })}
    >
      <SectionTrail
        sections={sections}
        ariaLabel="Onboarding progress"
        onStepClick={gateLocked ? undefined : handleStepClick}
      />
    </div>
  );
}
